<template>
    <div>
        <div :class="$spa.css.layout.header">
            <div class="flex items-center flex-shrink-0 w-auto px-4">
                <img class="block mr-4 md:hidden" style="height: 20px;" src="/spa/menu.svg" alt="Menu icon" @click.prevent="toggleResponsiveSidebar"/>
                <a :href="$store.state.user ? $store.state.user.links.account : 'https://www.trustup.pro'" class="hidden md:block">
                    <img src="https://www.trustup.pro/images/logo.svg" class="h-6 mr-1" />
                </a>
                <a href="/" class="flex items-center md:hidden" v-if="$spa.getCurrentApp()">
                    <img class="h-6 mr-1" :src="$spa.getCurrentApp().icon" alt="Current app icon" />
                    <span class="text-lg font-thin text-gray-800">
                        {{ $spa.getCurrentApp().name }}
                    </span>
                </a>
            </div>
            <div class="w-full pr-4">
                <div class="flex flex-wrap items-center h-full">
                    <div class="flex w-full h-full">
                        <div class="flex flex-wrap items-center flex-auto">
                            <slot name="next-to-title"></slot>
                        </div>
                        <div class="flex items-center h-full">

                            <div class="mr-4">
                                <v-spa-submenu-container :container="`${$spa.css.submenu.container.default} mt-[13px]`" position="right-0" ref="helpSubmenu">
                                    <template v-slot:default="slotProps">
                                        <div class="items-center hidden w-full px-4 py-2 rounded-full cursor-pointer sm:flex hover:bg-gray-100 text-slate-800" :class="{'bg-gray-100': $refs.helpSubmenu && $refs.helpSubmenu.isDisplayed}" @click="slotProps.toggle()">
                                            <span class="mr-2">
                                                {{ $t('help_submenu.label') }}
                                            </span>
                                            <i class="text-xs text-gray-600 fas" :class="$refs.helpSubmenu && $refs.helpSubmenu.isDisplayed ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </div>
                                    </template>
                                    <div class="w-[200px]" slot="submenu">
                                        <a :class="$spa.css.contextmenu.link" :href="helpLink($t('help_submenu.help.link'))" target="_blank">
                                            <i :class="`${$spa.css.contextmenu.icon} far fa-question`" />
                                            {{ $t('help_submenu.help.text') }}
                                        </a>
                                        <a :class="$spa.css.contextmenu.link" :href="helpLink($t('help_submenu.support.link'))" target="_blank">
                                            <i :class="`${$spa.css.contextmenu.icon} far fa-life-ring`" />
                                            {{ $t('help_submenu.support.text') }}
                                        </a>
                                        <a :class="$spa.css.contextmenu.link" href="#" @click.prevent="openIntercom" v-if="intercomIsInstalled">
                                            <i :class="`${$spa.css.contextmenu.icon} far fa-comments`" />
                                            {{ $t('help_submenu.chat.text') }}
                                        </a>
                                    </div>
                                </v-spa-submenu-container>
                            </div>

                            <v-spa-submenu-container :container="`${$spa.css.submenu.container.base} py-2 mt-[13px]`" position="right-0" ref="userSubmenu">
                                <template v-slot:default="slotProps">
                                    <div class="flex items-center w-full p-1 rounded-full cursor-pointer hover:bg-gray-100 text-slate-800" :class="{'bg-gray-100': $refs.userSubmenu && $refs.userSubmenu.isDisplayed}" @click="slotProps.toggle()">
                                        <img :src="$store.state.user.avatar" :alt="$store.state.user.name" class="w-6 h-6 mr-2 rounded-full md:h-8 md:w-8" />
                                        <span class="hidden mr-2 md:block">{{ $store.state.user.name }}</span>
                                        <i class="mr-3 text-xs text-gray-600 fas" :class="$refs.userSubmenu && $refs.userSubmenu.isDisplayed ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    </div>
                                </template>
                                <div class="w-[250px]" slot="submenu">
                                    <div class="px-2">
                                        <template v-for="(link, index) in $store.state.user.submenu_content.links">
                                            <a :key="`link-${index}`":href="link.href" class="flex items-center px-4 py-2 text-sm rounded-lg hover:bg-gray-100 text-slate-800 hover:text-black">
                                                <i :class="`${link.icon} mr-2 text-slate-600 w-6 text-center`"></i>
                                                {{ link.text }}
                                            </a>
                                        </template>
                                    </div>
                                    <div class="py-2">
                                        <div class="border-t border-gray-200"></div>
                                    </div>
                                    <div class="px-2">
                                        <template v-for="(professional, index) in $store.state.user.submenu_content.professionals">
                                            <a :key="`link-${index}`":href="professional.href" class="flex items-center w-full px-4 py-2 rounded hover:bg-gray-100">
                                                <img :src="professional.icon" class="w-6 h-6 mr-2 rounded-sm" />
                                                <p class="flex-1 text-sm text-gray-800">
                                                    {{ professional.text }}
                                                </p>
                                                <div class="w-4" v-if="professional.is_default">
                                                    <i class="text-sm text-gray-700 fas fa-check-circle"></i>
                                                </div>
                                            </a>
                                        </template>
                                    </div>
                                    <div class="py-2">
                                        <div class="border-t border-gray-200"></div>
                                    </div>
                                    <div class="px-2">
                                        <template v-for="(app, index) in $store.state.user.submenu_content.apps">
                                            <a :key="`link-${index}`":href="app.href" class="flex items-center w-full px-4 py-2 rounded hover:bg-gray-100" :class="{'bg-gray-100': app.is_active}">
                                                <img :src="app.icon" class="w-6 h-6 mr-2" />
                                                <p class="text-sm text-gray-800">
                                                    {{ app.text }}
                                                </p>
                                                <div class="flex justify-end flex-1" v-if="! app.is_available">
                                                    <span class="font-semibold text-white uppercase bg-yellow-600 rounded bg-trustup" style="background-color: #f8be14; font-size: 10px; padding: 3px; line-height: 10px">{{ $t('apps_sidebar.app_not_available') }}</span>
                                                </div>
                                            </a>
                                        </template>
                                    </div>
                                </div>
                            </v-spa-submenu-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed inset-0 flex flex-col overflow-y-auto bg-sidebar z-100" v-if="display.sidebar">
            <div class="absolute flex justify-end w-full">
                <div class="p-6 rounded-full cursor-pointer" @click.prevent="display.sidebar = false">
                    <img class="h-4" :src="responsiveMenuIcon" alt="Menu icon" />
                </div>
            </div>
            <div :class="responsiveSidebarClass">
                <slot name="responsive-sidebar"></slot>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .v--modal-block-scroll .z-index-modal,
    .vm--block-scroll .z-index-modal {
        z-index: 40;
    }
    .z-index-modal {
        z-index: 50;
    }
</style>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            responsiveSidebarClass: {
                type: String,
                default: 'p-8 flex-grow',
            },
            displayResponsiveMenuOnDesktop: {
                type: Boolean,
                default: false
            },
            responsiveMenuIcon: {
                type: String,
                default: '/spa/close-white.svg'
            }
        },
        data() {
            return {
                display: {
                    submenu: false,
                    sidebar: false
                }
            }
        },
        methods: {
            toggleResponsiveSidebar()
            {
                this.display.sidebar = ! this.display.sidebar;
            },
            hasEventBus()
            {
                return this.$bus ? true : false;
            },
            openIntercom()
            {
                this.$refs.helpSubmenu.hide();
                
                if ( window.Intercom ) {
                    window.Intercom('update', {
                        hide_default_launcher: false
                    });
                    window.Intercom('showNewMessage');
                }
            },
            helpLink(url)
            {
                const params = new URLSearchParams({
                    client_company_id: this.$store.state.user.default_professional.id,
                    client_company: this.$store.state.user.default_professional.company,
                    client_firstname: this.$store.state.user.first_name,
                    client_lastname: this.$store.state.user.last_name,
                    client_email: this.$store.state.user.email,
                    locale: this.$store.state.locale,
                    app: this.$spa.getCurrentApp().key,
                });

                if ( this.$store.state.account ) {
                    params.append('client_account_uuid', this.$store.state.account.uuid);
                }

                return `${url}?${params.toString()}`;
            }
        },
        computed: {
            ...mapState(['impersonateToken']),
            intercomIsInstalled() {
                return typeof window.Intercom === 'function';
            }
        },
        created()
        {
            if (this.hasEventBus()) {
                this.$bus.$on('spa:closeResponsiveSidebar', () => {
                    this.display.sidebar = false;
                });
            } 
        }
    }
</script>